import { push } from 'connected-react-router';

import {
  SETUP_INITIAL_DATA_REQUEST,
  SETUP_INITIAL_DATA_SUCCESS,
  SETUP_INITIAL_DATA_FAILURE
} from 'base/actions/actionTypes';
import { apiAction } from 'base/utils/apiHelpers';
import { SETUP_INITIAL_DATA_ENDPOINT } from 'base/constants/endpoints';
import { LOCATION_BASE } from 'locations/constants/paths';
import getCommerceType from 'utils/getCommerceType';

export const setupInitialData = ({ locationSlug }) => async dispatch => {
  const endpoint = SETUP_INITIAL_DATA_ENDPOINT;
  const result = await dispatch(
    apiAction(
      endpoint,
      'PUT',
      [
        SETUP_INITIAL_DATA_REQUEST,
        SETUP_INITIAL_DATA_SUCCESS,
        SETUP_INITIAL_DATA_FAILURE
      ],
      { location_slug: locationSlug, commerce_type: getCommerceType() }
    )
  );

  return result;
};

// pushes guest back to start on online ordering flow so
// their cart can bet setup properly; called when a request
// is made that expects a real cart, but it is not set on
// the session yet
export const restartOnlineOrderingFlow = () => dispatch => {
  dispatch(push(LOCATION_BASE));
  window.location.reload();
};
